export default "__VITE_ASSET__5782bef6__"